import React from 'react'
import { useNavigate } from 'react-router-dom';
import backBtn from '../../../../assets/images/home/back.svg'
import '../../../../scss/pages/pageview.css'

const Header = ({headtitle}) => {
    let navigate= useNavigate();
  return (
    <div className='subcardWrapper'>
        <div className="subheader">
            <div className="arrow" onClick={()=>{navigate(-1)}}>
                <img src={backBtn} className='img-fluid' alt="" />
            </div>
            <h2>{headtitle}</h2>
        </div>
    </div>
  )
}

export default Header